webpackJsonp([142629428675168],{

/***/ 428:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"IMBIBE - A Brand Design Firm","description":"We approach business challenges thoughtfully to deliver an extraordinary brand experience."}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-e384164c9b950c5496ce.js